import RedirectButton from './RedirectButton';

export default RedirectButton;